import { BlockInterface } from "interfaces/block.interface";

export enum BlockActionTypes {
  FETCH_BLOCK_REQUEST = "FETCH_BLOCK_REQUEST",
  FETCH_BLOCK_SUCCESS = "FETCH_BLOCK_SUCCESS",
  FETCH_BLOCK_FAILURE = "FETCH_BLOCK_FAILURE",
}

// Action interfaces
export interface FetchBlockRequestAction {
  type: BlockActionTypes.FETCH_BLOCK_REQUEST;
  payload: {
    height: number;
  };
}

export interface FetchBlockSuccessAction {
  type: BlockActionTypes.FETCH_BLOCK_SUCCESS;
  payload: BlockInterface;
}

export interface FetchBlockFailureAction {
  type: BlockActionTypes.FETCH_BLOCK_FAILURE;
  payload: string;
}

// Action creators
export const fetchBlockRequest = (height: number): FetchBlockRequestAction => ({
  type: BlockActionTypes.FETCH_BLOCK_REQUEST,
  payload: { height },
});

export const fetchBlockSuccess = (
  data: BlockInterface
): FetchBlockSuccessAction => ({
  type: BlockActionTypes.FETCH_BLOCK_SUCCESS,
  payload: data,
});

export const fetchBlockFailure = (error: string): FetchBlockFailureAction => ({
  type: BlockActionTypes.FETCH_BLOCK_FAILURE,
  payload: error,
});

export type BlockActions =
  | FetchBlockRequestAction
  | FetchBlockSuccessAction
  | FetchBlockFailureAction;
